// Component: SLTPProgressBar.jsx
// Purpose: Visual bar showing LTP position relative to SL/TP levels

import React from 'react';

export default function SLTPProgressBar({ sl, tp, entry, ltp, side }) {
  if (!sl || !tp || !ltp) return null;

  //--> Calculate LTP position as percentage between SL and TP
  const range = Math.abs(tp - sl);
  if (range === 0) return null;

  const position = side === 'LONG'
    ? ((ltp - sl) / range) * 100
    : ((sl - ltp) / (sl - tp)) * 100;

  const clampedPos = Math.max(0, Math.min(100, position));

  return (
    <div style={{ background: '#161b22', borderRadius: 8, padding: '10px 14px' }}>
      {/* Bar */}
      <div style={{ position: 'relative', height: 8, background: '#21262d', borderRadius: 4 }}>
        {/* SL zone gradient */}
        <div style={{
          position: 'absolute', left: 0, width: '28%', height: '100%',
          background: 'linear-gradient(90deg, #f8514966, #f8514900)', borderRadius: 4,
        }} />
        {/* TP zone gradient */}
        <div style={{
          position: 'absolute', right: 0, width: '28%', height: '100%',
          background: 'linear-gradient(270deg, #3fb95066, #3fb95000)', borderRadius: 4,
        }} />
        {/* LTP marker */}
        <div style={{
          position: 'absolute', left: `${clampedPos}%`, width: 10, height: 14, top: -3,
          background: '#58a6ff', borderRadius: 3, boxShadow: '0 0 6px #58a6ff55',
          transform: 'translateX(-50%)',
        }} />
      </div>
      {/* Labels */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', marginTop: 6, fontSize: 11,
      }}>
        <span style={{ color: '#f85149' }}>SL {sl?.toLocaleString('en-IN')}</span>
        <span style={{ color: '#3fb950' }}>TP {tp?.toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
}
